import type { DownsellAcceptResult, DownsellImpression, DownsellQuote } from '@/types/downsell'
import { gaItem, rememberOrder, trackPurchase, type GaCart } from './ecommerce'

/**
 * A last-chance offer (F-39) as Google Analytics sees it: the add-on, at what
 * is charged now (the server's quote, with the coupon when one was applied).
 */
export function downsellCart(offer: DownsellImpression, quote?: DownsellQuote | null): GaCart {
  const due = quote?.amountToCharge ?? offer.quote?.amountToCharge ?? offer.amountToCharge ?? offer.discountedPeriodAmount
  const value = parseFloat(String(due ?? '0')) || 0
  return {
    items: [gaItem({ id: offer.productId, title: offer.title }, { category: 'add_on', price: value })],
    value,
    currency: offer.currency,
    coupon: quote?.coupon?.code ?? null
  }
}

/**
 * The offer was accepted: `purchase` when the charge is already paid, the
 * order remembered when a PIX or boleto still has to be paid. Nothing charged
 * now (under the floor) joins the plan's next charge and is not a purchase yet.
 */
export function trackDownsellAccepted(result: DownsellAcceptResult | null | undefined, cart: GaCart, method: string | null) {
  if (!result?.purchaseId || !result.charged) return
  const charged = parseFloat(result.amount)
  const paidCart = Number.isFinite(charged) ? { ...cart, value: charged, currency: result.currency || cart.currency } : cart
  if (result.status === 'COMPLETED') trackPurchase(result.purchaseId, paidCart, result.paymentMethod || method)
  else rememberOrder(result.purchaseId, paidCart, result.paymentMethod || method)
}
